import { render } from "./EventHistoryWidget.vue?vue&type=template&id=0c5a9580&scoped=true"
import script from "./EventHistoryWidget.vue?vue&type=script&lang=js"
export * from "./EventHistoryWidget.vue?vue&type=script&lang=js"

import "./EventHistoryWidget.vue?vue&type=style&index=0&id=0c5a9580&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5a9580"],['__file',"src/containers/widget/components/EventHistoryWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c5a9580"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c5a9580', __exports__)) {
    api.reload('0c5a9580', __exports__)
  }
  
  module.hot.accept("./EventHistoryWidget.vue?vue&type=template&id=0c5a9580&scoped=true", () => {
    api.rerender('0c5a9580', render)
  })

}


export default __exports__